import React, { Component } from "react";
import moment from "moment";
import routes from "../../routes/URL";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import Table from "../../components/Table";
import { FloorDetailScreen } from "../FloorScreens";
import Toast from "../../components/Toast";

import Colors from "../../common/Colors";
class ListMenuScreen extends Component {
  constructor(props) {
    super(props);
    this.state = { data: [], mode: "blocks",
      toast:{
        show: false,
        message: "",
        type: "success",
      }
     };
  }
  componentDidMount() {
    // this.fetchData();
  }
  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  };

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  };

  fetchData = async () => {
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.listCustomBilling
    );
    if (status == "success") {
      this.setState({ data: data });
    } else {
      this.toast.showToast(message, "error");
     
    }
  };

  onDelete = async (item) => {
    console.log("sure to delete?");
    const { status, message, data } = await API(
      this,
      "post",
      URL_PATH.deleteMenu(item.id)
    );
    if (status == "success") {
      this.showToast(message, "success");
    this.setState({
      version: this.state.version + Math.random() + "",
    });
     
    } else
    this.showToast(message, "error");

  };
  onEdit = async (item) => {
    // this.props.history.push(routes.admin.users.update(item.id));
  };
  onView = async (item) => {
    // this.props.history.push("/floors/" + item.id);
  };

  onSwitch = async (item, value) => {
    console.log("Switch: ", item, value);
    const { status, message, data } = await API(
      this,
      "get",
      URL_PATH.updateMenuStatus,
      { menu_id: item.id, status: value }
    );
  };

  RenderTable = () => {
    return (
      <Table
        key={this.state.version}
        api={URL_PATH.listCustomBilling}
        onEdit={this.onEdit}
        // onDelete={this.onDelete}
        onView={this.onView}
        row={[
          {
            title: "Order Id",
            key: "id",
            sortable: true,
          },

          {
            title: "KOT Items",
            key: "kot",

            parseFunction: (item) => {
              //join all items with comma
              if (item.length == 0) return "";
              return item
                .map((item) => {
                  return item.kot_items
                    .map(
                      (item) => item.item_quantity + "x" + item.item_menu_name
                    )
                    .join(", ");
                })
                .join(". ");
            },
          },
          {
            title: "Time",
            key: "created_at",
            sortable: true,
            type: "date_from_now",
          },
          {
            title: "Order total",
            key: "order_total",
            sortable: true,
          },
          {
            title: "GST",
            key: "gst",
            sortable: true,
          },
          {
            title: "Grand total",
            key: "order_grand_total",
            sortable: true,
          },
        ]}
      />
    );
  };

  changeKOTStatus = async (item, status) => {
    console.log("changeKOTStatus: ", item, status);
    const {
      status: status1,
      message,
      data,
    } = await API(this, "get", URL_PATH.updateKOTStatus, {
      kot_id: item.id,
      status: status,
    });
    if (status1 != "success") {
      this.showToast(message, "error");
    return;
    }

    this.fetchData();
  };

  printKOT = (item) => {
    console.log("printKOT: ", item);
    document.getElementById("kot_action_" + item.id).style.display = "none";
    //"kot_logo_
    // document.getElementById("kot_logo_" + item.id).style.display = "block";

    document.getElementById("kot_" + item.id).style.margin = "0";
    var printContents = document.getElementById("kot_" + item.id).innerHTML;

    var windowUrl = "about:blank";
    var uniqueName = new Date();
    var windowName = "Print" + uniqueName.getTime();

    var printWindow = window.open(
      windowUrl,
      windowName,
      "left=0,top=0,width=0,height=0"
    );

    printWindow.document.write(printContents);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();

    document.getElementById("kot_action_" + item.id).style.display = "flex";
    document.getElementById("kot_" + item.id).style.margin = "10px";
    // document.getElementById("kot_logo_" + item.id).style.display = "none";
  };

  renderOption = ({ value, status_, childrean }) => {
    // return null;
    if (value == status_)
      return (
        <option value={value} selected={value}>
          {childrean}
        </option>
      );

    return <option value={value}>{childrean}</option>;
  };

  renderBlocks = () => {
    const { data } = this.state;
    return (
      <div className="row d-flex flex-row justify-center flex-wrap">
        {data.map((item, index) => {
          return (
            <div
              id={"kot_" + item.id}
              key={index}
              className=" col-lg-3 p-3"
              style={{
                margin: 10,
                backgroundColor: Colors.pageBgColor,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",

                // width: "58mm",
              }}
            >
              {/* logo */}
              {/* <div
                                style={{
                                    //center image horizontally
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginBottom: "5px",
                                }}
                            >
                                <img
                                    id={"kot_logo_" + item.id}
                                    src="/logo2.png"
                                    style={{
                                        display: "none",
                                        width: "75%",
                                        height: "auto",
                                    }}
                                />
                            </div> */}
              <div>
                <div
                  style={{
                    paddingBottom: "5px",
                    borderBottom: "1px solid #ccc",
                    marginBottom: "5px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      //horizontally center elements
                      textAlign: "center",
                    }}
                  >
                    {item.hotel_order_id}
                    <br />
                    {item.hotel_order.order_type == "dinein"
                      ? "Dine In"
                      : "Take Away"}
                    <br />
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {index + 1}
                    <br />
                    KOT No.
                  </div>
                  <div
                    style={{
                      //horizontally center elements
                      textAlign: "center",
                    }}
                  >
                    {moment(item.created_at).format("HH:mm")}
                    <br />
                    Time
                  </div>
                </div>
                {/* customer */}
                <h5
                  className="card-subtitle "
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    marginBottom: "5px",
                  }}
                >
                  <span> {item.hotel_order.user.name}</span>
                  <span> {item.hotel_order.user.mobile}</span>
                </h5>

                {/* table no */}
                {item.hotel_order.order_type == "dinein" && (
                  <h5 className="card-subtitle">{item.table}</h5>
                )}
                {/* menus */}
                <div
                  style={{
                    marginTop: "5px",
                    paddingTop: "5px",
                    borderTop: "1px solid #ccc",
                  }}
                >
                  <table width="100%">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Item</th>
                        <th>Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {item.kot_items.map((item, index) => (
                        <tr>
                          <td
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td> {item.item_menu_name}</td>
                          <td
                            style={{
                              textAlign: "center",
                            }}
                          >
                            {item.item_quantity}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div>
                {/* Status */}
                <h4
                  className="card-text"
                  style={{
                    borderTop: "1px solid #ccc",
                    paddingTop: "5px",
                    marginTop: "10px",
                    textAlign: "center",
                  }}
                >
                  Status :{" "}
                  {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                </h4>
                {/* Actions */}
                <div
                  className="d-flex row flex-wrap justify-between align-items-center mt-1"
                  id={"kot_action_" + item.id}
                >
                  <div className="col-6">
                    <select
                      className="form-control col-12"
                      onChange={(e) => {
                        this.changeKOTStatus(item, e.target.value);
                      }}
                    >
                      {this.renderOption({
                        value: "pending",
                        status_: item.status,
                        childrean: "Pending",
                      })}
                      {this.renderOption({
                        value: "cooking",
                        status_: item.status,
                        childrean: "Cooking",
                      })}
                      {this.renderOption({
                        value: "served",
                        status_: item.status,
                        childrean: "Served",
                      })}
                      {this.renderOption({
                        value: "cancelled",
                        status_: item.status,
                        childrean: "Cancelled",
                      })}
                    </select>
                  </div>
                  <div className="col-6">
                    <div
                      className="col-12 btn btn-primary "
                      style={{
                        backgroundColor: Colors.primary,
                      }}
                      onClick={() => {
                        this.printKOT(item);
                      }}
                    >
                      <i className="fa fa-print" style={{ color: "black" }}>
                        Print
                      </i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    const { data, mode } = this.state;
    return (
      <div className="container-fluid">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <h1>Custom Orders</h1>
          <div
            className="btn btn-primary"
            onClick={() => {
              this.props.history.push(routes.admin.customBilling.create);
              // location.history.push("/hotel/create");
            }}
          >
            New Custom Bill
          </div>
        </div>
        <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        onClose={this.handleCloseToast}
      />
        {/* {mode == "table" &&  */}
        <this.RenderTable />
        {/* // }{mode == "blocks" && this.renderBlocks()} */}
      </div>
    );
  }
}

export default redux(ListMenuScreen);
